export enum DonationChannel {
  TWILIO_PRIORITY = 'twilio_priority',
  TWILIO_FLEX_PRIORITY = 'twilio_flex_priority',
  DONOR_APP_PRIORITY = 'donor_app_priority',
  DONOR_APP_V2_PRIORITY = 'donor_app_v2_priority',
  DONOR_APP_V2_STANDARD = 'donor_app_v2_standard',
  CAPTAIN_APP_PRIORITY = 'captain_app_priority',
}

export const DONATION_CHANNELS = [
  {
    value: DonationChannel.DONOR_APP_PRIORITY,
    viewValue: 'Donor App Priority',
  },
  {
    value: DonationChannel.DONOR_APP_V2_PRIORITY,
    viewValue: 'Donor App V2 Priority',
  },
  {
    value: DonationChannel.DONOR_APP_V2_STANDARD,
    viewValue: 'Donor App V2 Standard',
  },
  {
    value: DonationChannel.CAPTAIN_APP_PRIORITY,
    viewValue: 'Captain App Priority',
  },
  {
    value: DonationChannel.TWILIO_PRIORITY,
    viewValue: 'Twilio Priority',
  },
  {
    value: DonationChannel.TWILIO_FLEX_PRIORITY,
    viewValue: 'Twilio Flex Priority',
  },
];
